import appLogger from "../../infra/logger/appLogger";
const conversationLogger = appLogger.withTag("Conversation");
export default conversationLogger;
